import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Box } from "@material-ui/core";
import { Image as ImageAtom } from "@components/atoms";
import icon_placeholder from "@assets/images/icon_placeholder.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "70%",
    width: "70%",
  },
  featureCheck: {
    marginRight: theme.spacing(1),
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 20,
    fontSize: "40px",
    textAlign: "center",
    borderRadius: 20,
    color: theme.palette.text.primary,
    "&:hover": {
      background:theme.palette.background.dashButton,
    },
  },
  logoSquare: {
    width: '20%',
  },
  logoRectangle: {
    width: '60%',
  },
  a: {
    textDecoration: "none",
  },
  iconColor: {
    color: theme.palette.icon.primary,
  },
}));

/**
 * Component to display the job card
 *
 * @param {Object} props
 */
const ExternalApplicationLink = (props) => {
  const { name, logo, icon, externalLink, className, key, ...rest } = props;

  const [isSquare, setIsSquare] = useState(false);
  const classes = useStyles();

  const getHeightAndWidthOfImage = useCallback(() => {
    const img = new Image();
    img.onload = function() {
      if (this.height === this.width) {
        setIsSquare(true);
      } else {
        setIsSquare(false);
      }
    }
    img.src = logo;
  }, [logo]);

  useEffect(() => {
    getHeightAndWidthOfImage();
  }, [logo]);

  return (
    <a key={key} href={externalLink} style={{ textDecoration: 'none', fontWeight: "bold", fontSize: 20 }} target="_blank" rel="noreferrer">
      <div className={isSquare ? clsx(classes.logoSquare, classes.logoContainer) : clsx(classes.logoRectangle, classes.logoContainer)}>
        {icon && (
          <FontAwesomeIcon
            icon={icon}
            size="4x"
            className={classes.iconColor}
          />
        )}
        {logo && (
          <ImageAtom
            src={logo ? logo : icon_placeholder}
            lazy={false}
          />
        )}

        <div fontWeight="fontWeightBold" m={1}>
          <Typography style={{ fontWeight: "bold", fontSize: "12px" }}>{name}</Typography>
        </div>

      </div>
    </a>
  );
};

ExternalApplicationLink.propTypes = {
  /**
   *  DOM Key
   */
  key: PropTypes.string,
  /**
   *  External classes
   */
  className: PropTypes.string,
  /**
   * Name of the application
   */
  name: PropTypes.string.isRequired,
  /**
   * Logo of application
   */
  logo: PropTypes.string.isRequired,
  /**
   * Link for application
   */
  externalLink: PropTypes.string.isRequired,
};

export default ExternalApplicationLink;
